import { css } from '@emotion/react';
import { getTypographyStyle } from '../typography';

export const sectionTitle = css`
  ${getTypographyStyle('subtitle-home')}
`;
